import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { TypographyTextProps } from "@portal/BaseComponents/Typography/type";
import { useFormats } from "@portal/hooks/use-formats";
import { amountFormats } from "@sinecycle/growcomponents";
import { useSearchParams } from "react-router-dom";
import { InvoicesColumns } from "./InvoicesColumn";

interface InvoicesTextProps {
  invoice: InvoicesColumns;
  textStyle?: { amount?: TypographyTextProps; title?: TypographyTextProps };
  hide?: {
    amount?: boolean;
    title?: boolean;
  };
  overRideStyle?: React.CSSProperties;
  onClick?: (id: string) => void;
}
function InvoicesText(props: InvoicesTextProps) {
  const [, setSearchParams] = useSearchParams();
  const { invoice, textStyle, hide, overRideStyle, onClick } = props;
  const { locale } = useFormats();
  function handleClick() {
    onClick?.(invoice.id);
    setSearchParams({ invoice_id: invoice.id });
  }
  const Title = (
    <HideWrapper hide={Boolean(hide?.title)}>
      <TypographyText
        fs="14"
        style={{
          color: "var(--primary-7)",
          cursor: "pointer",
          maxWidth: textStyle?.title?.ellipsis ? "80px" : undefined,
        }}
        onClick={handleClick}
        {...textStyle?.title}
      >
        {invoice.title}
      </TypographyText>
    </HideWrapper>
  );
  const Amount = (
    <HideWrapper hide={Boolean(hide?.amount)}>
      <TypographyText
        fs="14"
        style={{ textAlign: "right" }}
        {...textStyle?.amount}
      >
        {amountFormats.amountShort(invoice.amount, {
          currency: invoice.currency ?? "USD",
          locale,
        })}
      </TypographyText>
    </HideWrapper>
  );
  return (
    <Flex
      align="center"
      style={{ width: "100%", ...overRideStyle }}
      justify="space-between"
    >
      {Title}
      {Amount}
    </Flex>
  );
}

export { InvoicesText };
